export default "__VITE_ASSET__Cur5DhfX__"